import { AppMode } from '@k-ucap/shared';

export interface AppConfig {
  appName: string;
  appFullName: string;
  appEnv: string;
  firebase: {
    apiKey: string;
    authDomain: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
    measurementId: string;
  };
  functionsRegion: string;
  useEmulator: boolean;
  dataEnvironment: string;
  enableEmailLogin: boolean;
  enableGoogleLogin: boolean;
  enableAnonymousLogin: boolean;
  cesiumIonToken: string;
}

export const getAppConfig = (): AppConfig => ({
  appName: import.meta.env.VITE_APP_NAME || 'K-UCAP',
  appFullName: import.meta.env.VITE_APP_FULL_NAME || 'Korea Unmanned System Conformance Assessment Platform',
  appEnv: import.meta.env.VITE_APP_ENV || 'development',
  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY || '',
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || '',
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || '',
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || '',
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '',
    appId: import.meta.env.VITE_FIREBASE_APP_ID || '',
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || '',
  },
  functionsRegion: import.meta.env.VITE_FIREBASE_FUNCTIONS_REGION || 'asia-northeast3',
  useEmulator: import.meta.env.VITE_FIREBASE_USE_EMULATOR === 'true',
  dataEnvironment: import.meta.env.VITE_DATA_ENVIRONMENT || 'development',
  enableEmailLogin: import.meta.env.VITE_ENABLE_EMAIL_LOGIN !== 'false',
  enableGoogleLogin: import.meta.env.VITE_ENABLE_GOOGLE_LOGIN !== 'false',
  enableAnonymousLogin: import.meta.env.VITE_ENABLE_ANONYMOUS_LOGIN === 'true',
  cesiumIonToken: import.meta.env.VITE_CESIUM_ION_TOKEN || '',
});

export const hasFirebaseConfig = (config: AppConfig): boolean =>
  Boolean(config.firebase.apiKey && config.firebase.authDomain && config.firebase.projectId && config.firebase.appId);

export const determineAppMode = (config: AppConfig, initialized: boolean, error: boolean): AppMode => {
  if (error) return AppMode.CONFIG_ERROR;
  if (!hasFirebaseConfig(config)) return AppMode.MOCK;
  if (!initialized) return AppMode.CONFIG_ERROR;
  return AppMode.FIREBASE;
};
